import type { BadgeVariant } from "@/components/ui/badge/badge.variants";

/**
 * How hard a metered plan resource (seats, AI tokens) is being pushed.
 * Always derived from the **percent used**, never percent remaining, so seats
 * and tokens read on the same axis wherever they are shown together.
 */
export type UsageStatus = "healthy" | "warning" | "critical";

/**
 * The one usage-pressure rule for the whole subscription surface — the header
 * plan hub and the seat / token management cards all resolve color through
 * this, so a bar can never be amber in one place and purple in another.
 */
export function usageStatus(percentUsed: number): UsageStatus {
  if (percentUsed >= 90) return "critical";
  if (percentUsed >= 75) return "warning";
  return "healthy";
}

/** Progress-bar fill. */
export const USAGE_BAR_CLASS: Record<UsageStatus, string> = {
  healthy: "bg-primary",
  warning: "bg-warning",
  critical: "bg-danger",
};

/** Ring arc — the stroke twin of `USAGE_BAR_CLASS`. */
export const USAGE_RING_CLASS: Record<UsageStatus, string> = {
  healthy: "stroke-primary",
  warning: "stroke-warning",
  critical: "stroke-danger",
};

/** Percent chips route through the canonical Badge rather than raw classes. */
export const USAGE_BADGE_VARIANT: Record<UsageStatus, BadgeVariant> = {
  healthy: "primary",
  warning: "warning",
  critical: "danger",
};
